export default __webpack_public_path__ + "assets/images/hearts.414ca33760f5fc7204d97ae0354f6017.png";